module.exports = __webpack_public_path__ + "img/icon_map_xmmg.04eec00e.png";